import { Icon, IconProps } from "..";

export const Knife = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.4173 5H17.24V6.16569H16.0743V7.33139H14.9086V8.49708H13.7429V9.66278H12.5772V10.8285H11.4115V11.9942H10.2458V13.1599H9.08009V14.3256H7.9144V15.4912H6.7487V16.6569H5.58301V17.8343H6.7487V19H9.09176V17.8343H10.2575V16.6686H11.4231V15.5029H12.5772V16.6686H13.7545V15.5029H14.9202V14.3372H16.0859V13.1715H17.2516V12.0058H18.4173V5ZM9.08009 17.8226V16.6686H7.92606V17.8226H9.08009ZM10.2458 16.6569H9.09176V15.5029H10.2458V16.6569ZM10.2575 14.3372V15.4912H11.4115V14.3372H10.2575Z"
          fill="currentColor"
        />
      </>
    </Icon>
  );
};
